import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {PersistGate} from 'redux-persist/integration/react';
import './index.css';
import App from './app/App';
import * as serviceWorker from './serviceWorker';
import createStore from './app/store';
import {createMuiTheme, ThemeProvider} from '@material-ui/core/styles';
import axios from 'axios';

const {store, persistor} = createStore();

const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#2e9990',
      main: '#43DBCF',
      dark: '#68e2d8',
      contrastText: '#000',
    },
  },
});

//axios.defaults.baseURL = 'http://3s-bis.thingsw.com:3000';
axios.defaults.baseURL = 'https://3s-bis-server.thingsw.com';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
